module.exports = __webpack_public_path__ + "media/assets/images/icons/patient-page/myguardant-logo-302caf591660d1978240573b0287ca64.svg";